export default __webpack_public_path__ + "static/media/caravanraidershideoutnormal.075e754e.jpg";